module.exports = __webpack_public_path__ + "img/arrow.43af2a82.svg";